export default "__VITE_PUBLIC_ASSET__2801bf96__"